import { render, staticRenderFns } from "./TaslimReport.vue?vue&type=template&id=932b5880&scoped=true"
import script from "./TaslimReport.vue?vue&type=script&lang=js"
export * from "./TaslimReport.vue?vue&type=script&lang=js"
import style0 from "./TaslimReport.vue?vue&type=style&index=0&id=932b5880&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "932b5880",
  null
  
)

export default component.exports